import React from 'react';

import Spinner from '@atlaskit/spinner';

export default (): React.JSX.Element => (
	<Spinner testId="spinner" interactionName="load" label="Loading" />
);
